import React from 'react';

// Shared expand/collapse header for the collapsible edit sections. The whole header is the toggle; the
// chevron flips and aria-expanded/aria-controls track the body it owns.
export default function CollapsibleCardHeader({ title, collapsed, onToggle, controlsId }) {
    return (
        <div className="card-header p-0">
            <button
                type="button"
                className="btn btn-link demo-edit-section-toggle d-flex align-items-center justify-content-between w-100 text-left text-decoration-none text-reset p-3"
                aria-expanded={!collapsed}
                aria-controls={controlsId}
                onClick={onToggle}
            >
                <h2 className="demo-edit-section-title mb-0">{title}</h2>
                <i className={`fas fa-chevron-${collapsed ? 'down' : 'up'} ml-2`} aria-hidden="true" />
            </button>
        </div>
    );
}
